/* tslint:disable */
/* eslint-disable */
/* @relayHash dcc4ec8ae070f3d0db2496c8a52db8d6 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_BackgroundCheckDetail_QueryVariables = {
    uuid: string;
};
export type App_BackgroundCheckDetail_QueryResponse = {
    readonly backgroundCheck: {
        readonly " $fragmentRefs": FragmentRefs<"BackgroundCheckDetail_backgroundCheck">;
    };
};
export type App_BackgroundCheckDetail_Query = {
    readonly response: App_BackgroundCheckDetail_QueryResponse;
    readonly variables: App_BackgroundCheckDetail_QueryVariables;
};



/*
query App_BackgroundCheckDetail_Query(
  $uuid: UUID!
) {
  backgroundCheck(uuid: $uuid) {
    ...BackgroundCheckDetail_backgroundCheck
  }
}

fragment BackgroundCheckDetail_backgroundCheck on BackgroundCheck {
  uuid
  createdAt
  approvalDate
  expiresAt
  applicationSentAt
  applicationReceivedAt
  requestedDBS
  onlyDBS
  hasAllResponses
  idExpiryDate
  dbsExpiryDate
  isRenewal
  isVerification
  isCAA
  interviewNotes {
    yourName
    employmentDecider
  }
  interviewNotesSendLogs {
    sentAt
    emailAddress
  }
  delegate {
    uuid
    firstName
    lastName
    email
  }
  history {
    ...Timeline_history
    uuid
    isArchived
    responseSendLogs {
      emailAddress
      sentAt
    }
    employer {
      uuid
      application {
        uuid
        name
        contactEmail
        jobTitle
        dates {
          startDate
          endDate
        }
      }
      response {
        uuid
        orgName
        orgContactName
        datesEmployed {
          startDate
          endDate
        }
      }
    }
    education {
      uuid
      application {
        uuid
        name
        contactEmail
        dates {
          startDate
          endDate
        }
      }
      response {
        uuid
        orgName
        orgContactName
        dates {
          startDate
          endDate
        }
      }
    }
    selfEmployed {
      uuid
      application {
        uuid
        accountantName
        contactEmail
        dates {
          startDate
          endDate
        }
      }
      response {
        uuid
        orgName
        orgContactName
        dates {
          startDate
          endDate
        }
      }
    }
    unemployed {
      uuid
      application {
        uuid
        dates {
          startDate
          endDate
        }
      }
      response {
        uuid
        alternateDates {
          startDate
          endDate
        }
      }
    }
  }
}

fragment Timeline_history on BackgroundHistory {
  uuid
  isArchived
  responseSendLogs {
    sentAt
    emailAddress
  }
  employer {
    uuid
    responseLink
    application {
      uuid
      name
      contactEmail
      jobTitle
      reasonForLeaving
      dates {
        startDate
        endDate
      }
      address {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
      absent
    }
    response {
      uuid
      datesEmployed {
        startDate
        endDate
      }
      positionsHeld
      reasonForLeaving
      wouldEmploy
      wouldEmployReason
      absence
      datesAbsent {
        startDate
        endDate
      }
      otherInformation
      orgName
      orgContactName
      orgJobTitle
      orgTelephone
      orgAddress {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
    }
  }
  education {
    uuid
    responseLink
    application {
      uuid
      name
      contactEmail
      dates {
        startDate
        endDate
      }
      examsTaken
      address {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
    }
    response {
      uuid
      dates {
        startDate
        endDate
      }
      courseDetails
      examResults
      otherInformation
      orgName
      orgContactName
      orgJobTitle
      orgTelephone
      orgAddress {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
    }
  }
  unemployed {
    uuid
    responseLink
    application {
      uuid
      dates {
        startDate
        endDate
      }
      reasonForUnemployment
      hadBenefits
    }
    response {
      uuid
      datesAccurate
      alternateDates {
        startDate
        endDate
      }
      lengthKnown
      relation
      inUK
      travelDetails
      employed
      employedDetails
      whereLived
      whatDoing
      financialSupport
      lacksIntegrity
      integrityDetail
      otherInformation
      occupation
      unavailableFrom
      firstName
      lastName
      daytimeTelephone
      homeTelephone
      address {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
    }
  }
  selfEmployed {
    uuid
    responseLink
    application {
      uuid
      accountantName
      contactEmail
      dates {
        startDate
        endDate
      }
      address {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
    }
    response {
      uuid
      dates {
        startDate
        endDate
      }
      selfEmploymentDetails
      businessName
      tradingName
      lacksIntegrity
      integrityDetail
      otherInformation
      orgName
      orgContactName
      orgJobTitle
      orgTelephone
      orgAddress {
        addressLine1
        addressLine2
        county
        postCode
        country
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "uuid",
            "type": "UUID!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "uuid",
            "variableName": "uuid"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v3 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "sentAt",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "emailAddress",
            "args": null,
            "storageKey": null
        } as any)
    ], v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "responseLink",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "contactEmail",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "reasonForLeaving",
        "args": null,
        "storageKey": null
    } as any), v10 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "startDate",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "endDate",
            "args": null,
            "storageKey": null
        } as any)
    ], v11 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "dates",
        "storageKey": null,
        "args": null,
        "concreteType": "HistoryDates",
        "plural": true,
        "selections": (v10 /*: any*/)
    } as any), v12 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine1",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine2",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "county",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "postCode",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "country",
            "args": null,
            "storageKey": null
        } as any)
    ], v13 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "address",
        "storageKey": null,
        "args": null,
        "concreteType": "Address",
        "plural": false,
        "selections": (v12 /*: any*/)
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "otherInformation",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgName",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgContactName",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgJobTitle",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgTelephone",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "orgAddress",
        "storageKey": null,
        "args": null,
        "concreteType": "Address",
        "plural": false,
        "selections": (v12 /*: any*/)
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lacksIntegrity",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "integrityDetail",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_BackgroundCheckDetail_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "backgroundCheck",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "BackgroundCheck",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "BackgroundCheckDetail_backgroundCheck",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_BackgroundCheckDetail_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "backgroundCheck",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "BackgroundCheck",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "createdAt",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "approvalDate",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "expiresAt",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "applicationSentAt",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "applicationReceivedAt",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "requestedDBS",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "onlyDBS",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasAllResponses",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "idExpiryDate",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "dbsExpiryDate",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isRenewal",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isVerification",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isCAA",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "interviewNotes",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "InterviewNotes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "yourName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "employmentDecider",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "interviewNotesSendLogs",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "InterviewNotesLog",
                            "plural": true,
                            "selections": (v3 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "delegate",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Delegate",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "history",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BackgroundHistory",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isArchived",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "responseSendLogs",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ResponseSendLog",
                                    "plural": true,
                                    "selections": (v3 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "employer",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BackgroundHistoryEmployer",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v6 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "application",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BackgroundCheckEmployerApplication",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v7 /*: any*/),
                                                (v8 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "jobTitle",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v9 /*: any*/),
                                                (v11 /*: any*/),
                                                (v13 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "absent",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "response",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BackgroundCheckEmployerResponse",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "datesEmployed",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "HistoryDates",
                                                    "plural": true,
                                                    "selections": (v10 /*: any*/)
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "positionsHeld",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v9 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "wouldEmploy",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "wouldEmployReason",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "absence",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "datesAbsent",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "HistoryDates",
                                                    "plural": true,
                                                    "selections": (v10 /*: any*/)
                                                },
                                                (v14 /*: any*/),
                                                (v15 /*: any*/),
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                (v18 /*: any*/),
                                                (v19 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "education",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BackgroundHistoryEducation",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v6 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "application",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BackgroundCheckEducationApplication",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v7 /*: any*/),
                                                (v8 /*: any*/),
                                                (v11 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "examsTaken",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v13 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "response",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BackgroundCheckEducationResponse",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v11 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "courseDetails",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "examResults",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v14 /*: any*/),
                                                (v15 /*: any*/),
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                (v18 /*: any*/),
                                                (v19 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "unemployed",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BackgroundHistoryUnemployed",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v6 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "application",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BackgroundCheckUnemployedApplication",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v11 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "reasonForUnemployment",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hadBenefits",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "response",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BackgroundCheckUnemployedResponse",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "datesAccurate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "alternateDates",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "HistoryDates",
                                                    "plural": true,
                                                    "selections": (v10 /*: any*/)
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "lengthKnown",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "relation",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inUK",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "travelDetails",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "employed",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "employedDetails",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "whereLived",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "whatDoing",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "financialSupport",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v20 /*: any*/),
                                                (v21 /*: any*/),
                                                (v14 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "occupation",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "unavailableFrom",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v4 /*: any*/),
                                                (v5 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "daytimeTelephone",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "homeTelephone",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v13 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "selfEmployed",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BackgroundHistorySelfEmployed",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v6 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "application",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BackgroundCheckSelfEmployedApplication",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "accountantName",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v8 /*: any*/),
                                                (v11 /*: any*/),
                                                (v13 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "response",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BackgroundCheckSelfEmploymentResponse",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v11 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "selfEmploymentDetails",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "businessName",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "tradingName",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v20 /*: any*/),
                                                (v21 /*: any*/),
                                                (v14 /*: any*/),
                                                (v15 /*: any*/),
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                (v18 /*: any*/),
                                                (v19 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_BackgroundCheckDetail_Query",
            "id": null,
            "text": "query App_BackgroundCheckDetail_Query(\n  $uuid: UUID!\n) {\n  backgroundCheck(uuid: $uuid) {\n    ...BackgroundCheckDetail_backgroundCheck\n  }\n}\n\nfragment BackgroundCheckDetail_backgroundCheck on BackgroundCheck {\n  uuid\n  createdAt\n  approvalDate\n  expiresAt\n  applicationSentAt\n  applicationReceivedAt\n  requestedDBS\n  onlyDBS\n  hasAllResponses\n  idExpiryDate\n  dbsExpiryDate\n  isRenewal\n  isVerification\n  isCAA\n  interviewNotes {\n    yourName\n    employmentDecider\n  }\n  interviewNotesSendLogs {\n    sentAt\n    emailAddress\n  }\n  delegate {\n    uuid\n    firstName\n    lastName\n    email\n  }\n  history {\n    ...Timeline_history\n    uuid\n    isArchived\n    responseSendLogs {\n      emailAddress\n      sentAt\n    }\n    employer {\n      uuid\n      application {\n        uuid\n        name\n        contactEmail\n        jobTitle\n        dates {\n          startDate\n          endDate\n        }\n      }\n      response {\n        uuid\n        orgName\n        orgContactName\n        datesEmployed {\n          startDate\n          endDate\n        }\n      }\n    }\n    education {\n      uuid\n      application {\n        uuid\n        name\n        contactEmail\n        dates {\n          startDate\n          endDate\n        }\n      }\n      response {\n        uuid\n        orgName\n        orgContactName\n        dates {\n          startDate\n          endDate\n        }\n      }\n    }\n    selfEmployed {\n      uuid\n      application {\n        uuid\n        accountantName\n        contactEmail\n        dates {\n          startDate\n          endDate\n        }\n      }\n      response {\n        uuid\n        orgName\n        orgContactName\n        dates {\n          startDate\n          endDate\n        }\n      }\n    }\n    unemployed {\n      uuid\n      application {\n        uuid\n        dates {\n          startDate\n          endDate\n        }\n      }\n      response {\n        uuid\n        alternateDates {\n          startDate\n          endDate\n        }\n      }\n    }\n  }\n}\n\nfragment Timeline_history on BackgroundHistory {\n  uuid\n  isArchived\n  responseSendLogs {\n    sentAt\n    emailAddress\n  }\n  employer {\n    uuid\n    responseLink\n    application {\n      uuid\n      name\n      contactEmail\n      jobTitle\n      reasonForLeaving\n      dates {\n        startDate\n        endDate\n      }\n      address {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n      absent\n    }\n    response {\n      uuid\n      datesEmployed {\n        startDate\n        endDate\n      }\n      positionsHeld\n      reasonForLeaving\n      wouldEmploy\n      wouldEmployReason\n      absence\n      datesAbsent {\n        startDate\n        endDate\n      }\n      otherInformation\n      orgName\n      orgContactName\n      orgJobTitle\n      orgTelephone\n      orgAddress {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n    }\n  }\n  education {\n    uuid\n    responseLink\n    application {\n      uuid\n      name\n      contactEmail\n      dates {\n        startDate\n        endDate\n      }\n      examsTaken\n      address {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n    }\n    response {\n      uuid\n      dates {\n        startDate\n        endDate\n      }\n      courseDetails\n      examResults\n      otherInformation\n      orgName\n      orgContactName\n      orgJobTitle\n      orgTelephone\n      orgAddress {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n    }\n  }\n  unemployed {\n    uuid\n    responseLink\n    application {\n      uuid\n      dates {\n        startDate\n        endDate\n      }\n      reasonForUnemployment\n      hadBenefits\n    }\n    response {\n      uuid\n      datesAccurate\n      alternateDates {\n        startDate\n        endDate\n      }\n      lengthKnown\n      relation\n      inUK\n      travelDetails\n      employed\n      employedDetails\n      whereLived\n      whatDoing\n      financialSupport\n      lacksIntegrity\n      integrityDetail\n      otherInformation\n      occupation\n      unavailableFrom\n      firstName\n      lastName\n      daytimeTelephone\n      homeTelephone\n      address {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n    }\n  }\n  selfEmployed {\n    uuid\n    responseLink\n    application {\n      uuid\n      accountantName\n      contactEmail\n      dates {\n        startDate\n        endDate\n      }\n      address {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n    }\n    response {\n      uuid\n      dates {\n        startDate\n        endDate\n      }\n      selfEmploymentDetails\n      businessName\n      tradingName\n      lacksIntegrity\n      integrityDetail\n      otherInformation\n      orgName\n      orgContactName\n      orgJobTitle\n      orgTelephone\n      orgAddress {\n        addressLine1\n        addressLine2\n        county\n        postCode\n        country\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '182b672f7223fccadbd3d320725cfa10';
export default node;
